import { Controller } from "@hotwired/stimulus";
import CriticalSection from "promise-critical-section";

export default class extends Controller {
    static get values() {
        return {
            "likesUrl": String
        };
    }

    static get targets() {
        return ["tooltipContent"];
    }

    get isHoveredOrFocussed() {
        return this.isHovered || this.isFocussed;
    }

    constructor(context) {
        super(context);
        this.tooltipVisibilityCriticalSection = new CriticalSection();
    }

    connect() {
        if (this.hasTooltipContentTarget) {
            this.tooltip = new bootstrap.Tooltip(
                this.element,
                {
                    customClass: "c-feed__likes-tooltip",
                    html: true,
                    title: () => this.tooltipContentTarget.content.cloneNode(true),
                    trigger: "manual"
                }
            );
        }
    }

    disconnect() {
        if (this.tooltip) {
            this.tooltip.dispose();
            this.tooltip = null;
        }
    }

    async setHovered() {
        this.isHovered = true;
        await this.updateTooltipVisibility();
    }

    async unsetHovered() {
        this.isHovered = false;
        await this.updateTooltipVisibility();
    }

    async setFocussed() {
        this.isFocussed = true;
        await this.updateTooltipVisibility();
    }

    async unsetFocussed() {
        this.isFocussed = false;
        await this.updateTooltipVisibility();
    }

    async updateTooltipVisibility() {
        await this.tooltipVisibilityCriticalSection.enter();

        if (this.tooltip) {
            if (this.isHoveredOrFocussed) {
                if (!this.tooltip.tip?.classList.contains("show")) {
                    await new Promise(r => { setTimeout(r, 500) });

                    if (this.tooltip && this.isHoveredOrFocussed) {
                        this.tooltip.show();
                        this.tooltip.tip.addEventListener(
                            "mouseenter",
                            () => {
                                if (this.tooltip.tip.classList.contains("show")) {
                                    this.setHovered();
                                }
                            }
                        );
                        this.tooltip.tip.addEventListener(
                            "mouseleave",
                            () => {
                                if (this.tooltip.tip.classList.contains("show")) {
                                    this.unsetHovered();
                                }
                            }
                        );

                        if (!this.likesHtml) {
                            this.likesHtml = await fetch(this.likesUrlValue).then(r => r.text());
                        }

                        if (this.tooltip) {
                            this.tooltip.tip.querySelector(`.loading`).outerHTML = this.likesHtml;
                        }
                    }
                }
            } else if (this.tooltip.tip?.classList.contains("show")) {
                await new Promise(r => { setTimeout(r, 250) });

                if (this.tooltip && !this.isHoveredOrFocussed) {
                    this.tooltip.hide();
                }
            }
        }

        this.tooltipVisibilityCriticalSection.leave();
    }
}